var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconUpvoteLeftInactiveUnfilled = function SvgIconUpvoteLeftInactiveUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.135 18.51"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon / Upvote-Left Inactive Copy"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-heart",
    d: "M17.777 1.699a4.951 4.951 0 00-6.973.531l-.736.793-.736-.793a4.951 4.951 0 00-6.973-.531 5.789 5.789 0 00-.37 8.125l.9.976 2.573 2.773 3.758 4.058a1.136 1.136 0 001.693 0l7.231-7.808a5.785 5.785 0 00-.366-8.125z",
    fill: "none",
    stroke: "#000"
  }))));
};
export default SvgIconUpvoteLeftInactiveUnfilled;